import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetCrecaTradesHistoryService } from "@/features/accounts/creca/services/get-trades-history-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetCrecaTradesHistoryResponseModel } from "@/features/accounts/creca/services/get-trades-history-model";

export const useGetCrecaTradesHistory = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getCrecaTradesHistoryService = new GetCrecaTradesHistoryService();

  // クレカ取込履歴取得
  const getCrecaTradesHistory = async (
    accountGroupId: string,
    crecaAccountId: string,
    offset?: string,
  ): Promise<GetCrecaTradesHistoryResponseModel> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getCrecaTradesHistoryService.getCrecaTradesHistory({
        account_group_id: accountGroupId,
        creca_account_id: crecaAccountId,
        offset,
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getCrecaTradesHistory:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getCrecaTradesHistory: errorHandledAsync(getCrecaTradesHistory, setError),
  };
};
